<template>
  <form ref="shipmentForm">
    <div class="row">
      <div class="col-12">
        <div class="row">
          <!-- Reference -->
          <div class="col-12 col-sm-6">
            <div class="form-group">
              <label for="reference">Reference</label>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  v-model="reference"
                  required
                  id="reference"
                  placeholder="Enter Reference Number"
                />
              </div>
            </div>
          </div>

          <!-- Loading Date -->
          <div class="col-12 col-sm-6">
            <div class="form-group">
              <label for="loadingDate">Loading Date</label>
              <div class="input-group">
                <input
                  type="date"
                  class="form-control"
                  v-model="loadingDate"
                  required
                  id="loadingDate"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <!-- ETA -->
          <div class="col-12 col-sm-6">
            <div class="form-group">
              <label for="eta">ETA</label>
              <div class="input-group">
                <input
                  type="date"
                  class="form-control"
                  v-model="eta"
                  required
                  id="eta"
                />
              </div>
            </div>
          </div>

          <!-- Departure Date -->
          <div class="col-12 col-sm-6">
            <div class="form-group">
              <label for="departureDate">Departure Date</label>
              <div class="input-group">
                <input
                  type="date"
                  class="form-control"
                  v-model="departureDate"
                  required
                  id="departureDate"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6">
            <div class="form-group">
              <label for="vesselName">Vessel Name</label>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  v-model="vesselName"
                  required
                  id="vesselName"
                  placeholder="Enter Vessel Name"
                />
              </div>
            </div>
          </div>

          <!-- Point of Arrival -->
          <div class="col-12 col-sm-6">
            <div class="form-group">
              <label for="pointOfArrival">Point of Arrival</label>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  v-model="pointOfArrival"
                  required
                  id="autocomplete"
                  placeholder="Enter Point of Arrival"
                  ref="autocompleteInput"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { mapGetters } from "vuex";
import Dropdown from "../AddDispatch/Dropdown.vue";

export default {
  components: { Dropdown },
  name: "ShipmentDetails",
  props: {
    initialValues: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      reference: this.initialValues?.reference ?? "",
      loadingDate: this.initialValues?.loadingDate ?? "",
      eta: this.initialValues?.eta ?? "",
      departureDate: this.initialValues?.departureDate ?? "",
      vesselName: this.initialValues?.vesselName ?? "",
      pointOfArrival: this.initialValues?.pointOfArrival ?? "",
      showError: false,
      lat: this.initialValues?.lat ?? null,
      lng: this.initialValues?.lng ?? null,
    };
  },
  methods: {
    initializeAutocomplete() {
      const { google } = window;

      if (google?.maps) {
        this.geocoder = new google.maps.Geocoder();
        const input = document.getElementById("autocomplete");
        const autocomplete = new google.maps.places.Autocomplete(input);

        console.log(google);

        autocomplete.addListener("place_changed", () => {
          const place = autocomplete.getPlace();

          if (place && place.formatted_address) {
            // The address was found in the autocomplete list
            this.pointOfArrival = place.formatted_address;

            // Get latitude and longitude from the place object
            const latLng = place.geometry?.location;

            if (latLng) {
              this.lat = latLng.lat();
              this.lng = latLng.lng();
              console.log("Latitude:", this.lat);
              console.log("Longitude:", this.lng);
            }
          } else {
            // The address was not in the autocomplete list, use geocoding
            const inputAddress = document.getElementById("autocomplete").value;
            console.log(
              "Address not found in autocomplete, geocoding:",
              inputAddress
            );

            // Use the Geocoder to get latitude and longitude for the entered address
            this.geocoder.geocode(
              { address: inputAddress },
              (results, status) => {
                if (
                  status === google.maps.GeocoderStatus.OK &&
                  results.length > 0
                ) {
                  const result = results[0];

                  const latLng = result.geometry.location;
                  this.lat = latLng.lat();
                  this.lng = latLng.lng();

                  console.log("Geocoded Latitude:", this.lat);
                  console.log("Geocoded Longitude:", this.lng);
                } else {
                  console.error("Geocoding failed:", status);
                }
              }
            );
          }
        });
      }
    },

    validateForm() {
      const form = this.$refs.shipmentForm;
      if (!form.checkValidity()) {
        form.reportValidity();
        return false;
      }
      return true;
    },
    getFormData() {
      return {
        reference: this.reference,
        loadingDate: this.loadingDate,
        eta: this.eta,
        departureDate: this.departureDate,
        vesselName: this.vesselName,
        pointOfArrival: this.pointOfArrival,
        lat: this.lat,
        lng: this.lng,
      };
    },
  },
  mounted() {
    setTimeout(() => {
      this.$nextTick().then(() => this.initializeAutocomplete());
    }, 1000); // Delay of 2 seconds
  },
  watch: {
    initialValues: {
      handler(newValues) {
        if (newValues.reference) {
          this.$nextTick(() => {
            const autocompleteInput = this.$refs.autocompleteInput;
            if (autocompleteInput) {
              this.reference = newValues.reference || "";
              this.loadingDate = newValues.loadingDate || "";
              this.eta = newValues.eta || "";
              this.departureDate = newValues.departureDate || "";
              this.vesselName = newValues.vesselName || "";
              this.pointOfArrival = newValues.pointOfArrival || "";
              this.lat = newValues.lat ?? null;
              this.lng = newValues.lng ?? null;
            }
          });
        }
      },
      deep: true,
    },
  },
};
</script>
